import '@mui/lab/themeAugmentation'

import { createTheme as createMuiTheme } from '@mui/material/styles'
import variants from './variants'
import typography from './typography'
import breakpoints from './breakpoints'
import components from './components'
import shadows from './shadows'

import rh from 'helpers/css/rh'

const createTheme = (name) => {
  let themeConfig = variants.find((variant) => variant.name === name)

  if (!themeConfig) {
    themeConfig = variants[0]
  }

  return createMuiTheme(
    {
      spacing: 4,
      breakpoints,
      components,
      typography,
      shadows,
      palette: themeConfig.palette,
      rh,
    },
    {
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    }
  )
}

export default createTheme
